import React, { useEffect, useMemo } from 'react';

import { Box, Button, CircularProgress } from '@mui/material';
import { useUnit } from 'effector-react';
import { MRT_ColumnDef } from 'material-react-table';
import moment from 'moment';

import { TableGridLocal } from '../../../../components/TableGridLocal';
import { ClientDetails$, clientDetailsApi } from '../../../../effector/clientDetails';
import { ChartPoint } from '../../../../types/chart';

export const ProfitTable: React.FC<{ agreementId: string }> = ({ agreementId }) => {
  const { chart, isChartFullHistory } = useUnit(ClientDetails$);
  const isChartLoading = useUnit(clientDetailsApi.getChart.pending);

  useEffect(() => {
    clientDetailsApi.getChart({
      agreementId,
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    });
  }, [agreementId]);

  const columns = useMemo<MRT_ColumnDef<ChartPoint>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'Номер',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 't',
        header: 'Дата',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'security',
        header: 'Инструмент',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'weight',
        header: 'weight',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'price',
        header: 'Цена',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'execPrice',
        header: 'Цена исполнения',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'priceDiff',
        header: 'pricediff',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'timeDiff',
        header: 'timediff',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'stratPL',
        header: 'stratpl',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'pL',
        header: 'pl',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'v',
        header: 'summStratPL',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
      {
        accessorKey: 'vr',
        header: 'summClientPL',
        enableColumnFilter: false,
        enableColumnActions: false,
      },
    ],
    [],
  );

  return (
    <Box sx={{ mt: 2 }}>
      <TableGridLocal
        name="statistic-profit-table"
        columns={columns}
        data={chart}
        pageSize={50}
        totalRowCount={chart.length}
        bottomToolbarCustomActions={
          !isChartFullHistory ? (
            <Button
              variant="contained"
              onClick={() => clientDetailsApi.getChart({ agreementId })}
              disabled={isChartLoading}
              startIcon={isChartLoading ? <CircularProgress size={18} color="inherit" /> : undefined}
            >
              {isChartLoading ? 'Загрузка…' : 'Далее'}
            </Button>
          ) : undefined
        }
      />
    </Box>
  );
};
